module.exports = __webpack_public_path__ + "img/1523040495.7caf6af2.jpg";